module.exports = __webpack_public_path__ + "img/header.76cfb5b7.png";